import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
ReactDOM.createRoot(document.getElementById("root")).render(/*#__PURE__*/ _jsx(React.StrictMode, {
    children: /*#__PURE__*/ _jsx(App, {})
}));
